import { socialExport } from '@mi-front/api-clients';
import { UseQueryResult } from '@tanstack/react-query';

type UseSocialUploadParams = { id: string } | { id: { platform: string; key: string } };

type UseSocialUploadOptions = {
  enabled?: boolean;
};

export function useSocialUpload(
  params: UseSocialUploadParams,
  options: UseSocialUploadOptions = {},
): UseQueryResult<socialExport.UploadDto> {
  const { enabled = true } = options;

  if (typeof params.id === 'string') {
    return socialExport.useGetUpload(params.id, {
      query: {
        enabled: enabled && !!params.id,
        refetchInterval: (query: { state?: { data?: { isPending?: boolean } } }) => {
          return query?.state?.data?.isPending ? 5000 : false;
        },
      },
    }) as UseQueryResult<socialExport.UploadDto>;
  }

  if (typeof params.id === 'object' && params.id.platform && params.id.key) {
    return socialExport.useGetUploadByKey(
      params.id.key,
      params.id.platform as socialExport.GetUploadByKeyPathParamsPlatformEnumKey,
      {
        query: {
          enabled: enabled && !!params.id.key && !!params.id.platform,
          refetchInterval: (query: { state?: { data?: { isPending?: boolean } } }) => {
            return query?.state?.data?.isPending ? 5000 : false;
          },
        },
      },
    ) as UseQueryResult<socialExport.UploadDto>;
  }

  // This should never happen due to TypeScript, but handle it gracefully
  throw new Error('id must be either a string or an object with platform and key');
}
